import React, { useEffect, useState } from 'react';
import { useWatchlist } from '../useContext/WatchlistContext';
import { Link } from 'react-router-dom';

/**
 * Simple component to test watchlist status and navigation
 */
const WatchlistStatusTest = () => {
  const { watchlist, favorites, loading } = useWatchlist();
  const [localStorageData, setLocalStorageData] = useState({});

  useEffect(() => {
    const updateLocalStorageDisplay = () => {
      setLocalStorageData({
        watchlist: localStorage.getItem('watchlist') || 'Empty',
        favorites: localStorage.getItem('favorites') || 'Empty'
      });
    };

    updateLocalStorageDisplay();
    const interval = setInterval(updateLocalStorageDisplay, 1000);
    return () => clearInterval(interval);
  }, []);

  const testMovie = {
    id: 550,
    title: 'Fight Club',
    type: 'movie',
    poster_path: '/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    imgSrc: 'https://image.tmdb.org/t/p/w500/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    vote_average: 8.4,
    release_date: '1999-10-15',
    overview: 'A ticking-time-bomb insomniac and a slippery soap salesman channel primal male aggression into a shocking new form of therapy.',
    adult: false
  };

  return (
    <div className="container mt-5 text-white">
      <h2>Watchlist Status Test</h2>
      
      <div className="row mb-4">
        <div className="col-md-6">
          <div className="card bg-dark text-white">
            <div className="card-header">Current State</div>
            <div className="card-body">
              <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
              <p><strong>Watchlist Count:</strong> {watchlist.length}</p>
              <p><strong>Favorites Count:</strong> {favorites.length}</p>
              
              <h6>Watchlist Items:</h6>
              {watchlist.length > 0 ? (
                <ul>
                  {watchlist.map(item => (
                    <li key={`${item.type}-${item.id}`}>
                      {item.title} ({item.type}) - ID: {item.id}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No items in watchlist</p>
              )}

              <h6>Favorites Items:</h6>
              {favorites.length > 0 ? (
                <ul>
                  {favorites.map(item => (
                    <li key={`${item.type}-${item.id}`}>
                      {item.title} ({item.type}) - ID: {item.id}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No items in favorites</p>
              )}
            </div>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="card bg-dark text-white">
            <div className="card-header">Local Storage (Live)</div>
            <div className="card-body">
              <h6>'watchlist' key:</h6>
              <pre className="bg-secondary p-2 rounded text-wrap" style={{maxHeight: '200px', overflow: 'auto'}}>
                {localStorageData.watchlist}
              </pre>
              <h6 className="mt-3">'favorites' key:</h6>
              <pre className="bg-secondary p-2 rounded text-wrap" style={{maxHeight: '200px', overflow: 'auto'}}>
                {localStorageData.favorites}
              </pre>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card bg-dark text-white">
            <div className="card-header">Test Movie Data</div>
            <div className="card-body">
              <pre className="bg-secondary p-2 rounded">
                {JSON.stringify(testMovie, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card bg-dark text-white">
            <div className="card-header">Navigation Links</div>
            <div className="card-body">
              <Link to="/watchlist" className="btn btn-info me-2">Go to Watchlist Page</Link>
              <Link to="/watchlist?tab=favourite" className="btn btn-info me-2">Go to Favorites Tab</Link>
              <Link to="/" className="btn btn-primary me-2">Go to Homepage</Link>
              <button 
                onClick={() => window.location.reload()} 
                className="btn btn-warning"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="alert alert-info">
            <h5>Instructions:</h5>
            <ol>
              <li>Go to the homepage and click the heart (+) or add (+) buttons on any movie/TV show</li>
              <li>Check the browser console for debug logs</li>
              <li>Come back to this page to see if items were added</li>
              <li>Click the navigation links to verify items appear in the watchlist/favorites pages</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchlistStatusTest;
